import { CommentHeaderButton } from '@components/ArtBoard/Threads/components/CommentHeaderButton'
import {
  CircleCheck,
  CircleCheckFilled,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  onClick: () => void
  resolved: boolean
}

export const ResolveButton: React.FC<Props> = ({ onClick, resolved }) => {
  const tooltip = resolved ? 'Reopen thread' : 'Resolve thread'

  return (
    <CommentHeaderButton label={tooltip} onClick={onClick}>
      {!resolved && <CircleCheck width="16px" height="16px" />}
      {resolved && <CircleCheckFilled width="16px" height="16px" />}
    </CommentHeaderButton>
  )
}
